import { render, staticRenderFns } from "./PayDescDialog.vue?vue&type=template&id=5c66ff76&scoped=true&lang=pug&"
import script from "./PayDescDialog.vue?vue&type=script&lang=ts&"
export * from "./PayDescDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c66ff76",
  null
  
)

export default component.exports